<div class="container">

  <div class="request-form">
    <mat-stepper>
      <mat-step [stepControl]="userInfoGroup">
        <ng-template matStepLabel>Personal Information</ng-template>
        <ng-container [ngTemplateOutlet]="personalInfo"></ng-container>
        <div class="action-buttons single-button">
          <button
            mat-flat-button
            color="primary"
            [disabled]="userInfoGroup.invalid || userInfoGroup.pending"
            matStepperNext>
            Next
          </button>
        </div>
      </mat-step>

      @if (pocNeeded) {
        <mat-step [stepControl]="pocFormGroup">
          <ng-template matStepLabel>Federal Point of Contact</ng-template>
          <ng-container [ngTemplateOutlet]="pocInfo"></ng-container>
          <div class="action-buttons">
            <button mat-stroked-button matStepperPrevious>Back</button>
            <button mat-flat-button color="primary" [disabled]="pocFormGroup.invalid || pocFormGroup.pending" matStepperNext>
              Next
            </button>
          </div>
        </mat-step>
      }

      <mat-step [stepControl]="accountInfoGroup">
        <ng-template matStepLabel>Account Info</ng-template>
        <ng-container [ngTemplateOutlet]="accountInfo"></ng-container>
        <div class="action-buttons">
          <button mat-stroked-button matStepperPrevious>Back</button>
          <button
            class="submit"
            mat-raised-button
            color="primary"
            [disabled]="accountInfoGroup.invalid || accountInfoGroup.pending"
            (click)="onSubmit()">
            Submit
          </button>
        </div>
      </mat-step>
    </mat-stepper>
  </div>

  <ng-template #personalInfo>
    <form [formGroup]="userInfoGroup">

      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput  formControlName="firstName">
        @if (userInfoGroup.get('firstName')?.hasError('required')) {
          <mat-error>First name is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName">
        @if (userInfoGroup.get('lastName')?.hasError('required')) {
          <mat-error>Last name is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Organization</mat-label>
        <input matInput  formControlName="organization">
        @if (userInfoGroup.get('organization')?.hasError('required')) {
          <mat-error>Organization is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" (blur)="checkPocNeeded()">
        <mat-icon matSuffix>email</mat-icon>
        <mat-error>
          @if (userInfoGroup.get('email')?.hasError('required')) {
            <span> Email is required. </span>
          }
          @if (userInfoGroup.get('email')?.hasError('email')) {
            <span> Email is not a valid format. </span>
          }
          @if (userInfoGroup.get('email')?.getError('emailExists')) {
            <span>
              {{ userInfoGroup.get('email')?.getError('emailExists') }}
            </span>
          }
        </mat-error>
      </mat-form-field>
    </form>
  </ng-template>

  <ng-template #pocInfo>
    <form class="poc-form" [formGroup]="pocFormGroup">
      <div class="input-row">
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input type="text"  matInput formControlName="name" />
          <mat-error>
            @if (pocFormGroup.get('name')?.hasError('required')) {
              <span>POC name is required.</span>
            }
            @if (pocFormGroup.get('name')?.hasError('pattern')) {
              <span>POC name must consist of more than a space.</span>
            }
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Organization</mat-label>
          <input type="text"  matInput formControlName="organization" />
          <mat-error>
            @if (pocFormGroup.get('organization')?.hasError('required')) {
              <span>Organization is required.</span>
            }
            @if (pocFormGroup.get('organization')?.hasError('pattern')) {
              <span>POC organization must consist of more than a space.</span>
            }
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-row">
        <mat-form-field appearance="outline">
          <mat-label>Department</mat-label>
          <input type="text"  matInput formControlName="department" />
          <mat-error>
            @if (pocFormGroup.get('department')?.hasError('required')) {
              <span>Department is required.</span>
            }
            @if (pocFormGroup.get('department')?.hasError('pattern')) {
              <span>POC department must consist of more than a space.</span>
            }
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Job Title</mat-label>
          <input type="text"  matInput formControlName="title" />
          <mat-error>
            @if (pocFormGroup.get('title')?.hasError('required')) {
              <span>Job title is required.</span>
            }
            @if (pocFormGroup.get('title')?.hasError('pattern')) {
              <span>POC job title must consist of more than a space.</span>
            }
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-row">
        <mat-form-field appearance="outline">
          <mat-label>Work Email</mat-label>
          <input type="text"  matInput formControlName="email" />
          <mat-error>
            @if (pocFormGroup.get('email')?.hasError('required')) {
              <span>Email address is required.</span>
            }
            @if (pocFormGroup.get('email')?.hasError('email')) {
              <span> Email is not a valid format. </span>
            }
            @if (pocFormGroup.get('email')?.hasError('pattern')) {
              <span>POC email must consist of more than a space.</span>
            }
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Work Phone Number</mat-label>
          <input type="tel" matInput formControlName="telephone" />
          <mat-error>
            @if (pocFormGroup.get('telephone')?.hasError('required')) {
              <span>A phone number is required.</span>
            }
            @if (pocFormGroup.get('telephone')?.hasError('minlength' || 'maxlength')) {
              <span>Phone number must be 10 characters long.</span>
            }
          </mat-error>
        </mat-form-field>
      </div>

    </form>
  </ng-template>

  <ng-template #accountInfo>
    <form class="account-form" [formGroup]="accountInfoGroup">
      <mat-form-field appearance="outline">
        <mat-label>Username</mat-label>
        <input matInput formControlName="username">
        <mat-icon matSuffix>attribution</mat-icon>
        <mat-hint>You may use an email address as your username</mat-hint>
        <mat-error>
          @if (accountInfoGroup.get('username')?.hasError('required')) {
            <span>Username is required.</span>
          }
          @if (accountInfoGroup.get('username')?.getError('usernameExists')) {
            <span>
              {{ accountInfoGroup.get('username')?.getError('usernameExists') }}
            </span>
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Reason</mat-label>
        <textarea matInput  formControlName="reason" cdkTextareaAutosize cdkAutosizeMaxRows="5" cdkAutosizeMinRows="5"></textarea>
        @if (accountInfoGroup.get('reason')?.hasError('required')) {
          <mat-error>Account reason is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="password">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password">
        <mat-hint>Password must be at least 16 characters</mat-hint>
        <mat-error>
          @if (accountInfoGroup.get('password')?.hasError('required')) {
            <span>Password is required</span>
          }
          @if (accountInfoGroup.get('password')?.hasError('passwordComplexity')) {
            <span>
              {{ accountInfoGroup.get('password')?.getError('passwordComplexity') }}
            </span>
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Confirm Password</mat-label>
        <input matInput type="password" formControlName="confirmPassword">
        <mat-error>
          @if (accountInfoGroup.get('confirmPassword')?.hasError('required')) {
            <span>Confirm password is required</span>
          }
          @if (accountInfoGroup.get('confirmPassword')?.hasError('match')) {
            <span>Password must match</span>
          }
        </mat-error>
      </mat-form-field>
    </form>
  </ng-template>

</div>
<!--thisisareallyreallylongpassword-->


